module.exports = __webpack_public_path__ + "images/photo_loading_lt_215.png";